export const TRIAL_PREVIEW_BANNER_SESSION_KEY = 'grundriss-ai:trial-preview-banner-seen';
export const TRIAL_PREVIEW_BANNER_HIDE_DELAY_MS = 5_000;

export function hasSeenTrialPreviewBanner(storage = globalThis.sessionStorage) {
  try {
    return storage?.getItem(TRIAL_PREVIEW_BANNER_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markTrialPreviewBannerSeen(storage = globalThis.sessionStorage) {
  try {
    storage?.setItem(TRIAL_PREVIEW_BANNER_SESSION_KEY, '1');
  } catch {
    // Storage can be unavailable in private or restricted browser contexts.
  }
}
